import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AllowedCurrenciesState } from "../objects/allowedCurrenciesState";
import { Currency } from "../../currency/objects/currency";


const initialState: AllowedCurrenciesState = {
    currencies: [],
    allowed_currencies: [],
    loading: false,
};

export const allowedCurrencies = createSlice({
    name: 'allowedCurrencies',
    initialState,
    reducers: {
        setCurrencies: (state, action: PayloadAction<Currency[]>): AllowedCurrenciesState => ({
            ...state,
            currencies: action.payload,
        }),
        setAllowedCurrencies: (state, action: PayloadAction<number[]>): AllowedCurrenciesState => ({
            ...state,
            allowed_currencies: action.payload,
        }),
        setLoading: (state, action: PayloadAction<boolean>): AllowedCurrenciesState => ({
            ...state,
            loading: action.payload,
        }),
    },
});

export const { setCurrencies, setAllowedCurrencies, setLoading } = allowedCurrencies.actions;
export default allowedCurrencies;
